export const classes = {
	carousel: {
		height: '100%',
		zIndex: '3',
		'& .image-gallery-image img': {
			height: '100%'
		}
	},
	header: {
		padding: '24px 26px',
		backgroundColor: '#78CDD0',
		'@media (max-width:768px)': {
			width: '100%',
		}
	},
	title: {
		display: 'flex',
		justifyContent: 'space-between',
		fontWeight: '700',
		fontSize: '25px',
		fontFamily: 'Lato, sans-serif',
		color: '#ffffff',
		'@media (max-width:768px)': {
			fontSize: '24px',
			padding: '0px 0px 10px 0px',
			justifyContent: 'left',
		}
	},
	eventsCard: {
		marginLeft: '10%',
		marginRight: '10%',
		marginBottom: '40px',
		marginTop: '40px',
		position: 'relative',
		overflow: 'clip',
		boxShadow: '0px 1px 20px 0px rgba(0,0,0,0.07), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.06)',
		'@media (max-width:768px)': {
			marginLeft: '0',
			marginRight: '0',
			marginTop: '0',
			marginBottom: '5%',
			borderRadius: 0,
		}
	},
	eventsTimeFilter: {
		display: 'none',
		justifyContent: 'space-evenly',
		padding: '20px',
		fontFamily: 'Lato, sans-serif',
		fontWeight: '400',
		fontSize: '15px',
		fontStyle: 'normal',
		// '@media (max-width:900px)': {
		// 	flexWrap: 'wrap'
		// },
		'& button': {
			borderRadius: '30px',
			textTransform: 'none',
			borderColor: '#78CDD0',
			width: '20%',
			// '@media (max-width:900px)': {
			// 	width: '50% !important',
			// 	marginBottom: '5px'
			// },
		}
	},
	datePicker: {
		margin: '0px',
		backgroundColor: 'white',
		borderRadius: '4px',
		height :'40px',
		'& fieldset': {
			border: 'none',
		},
		'& input': {
			height: '40px',
			fontFamily: 'Lato, sans-serif',
			padding: '0px 10px'
		},
		'@media (max-width:768px)': {
			width: '100%',
		},
	},
	languageCheck: {
		'& span': {
			fontFamily: 'Lato, sans-serif',
			fontSize: '14px',
		},
	},
	select: {
		backgroundColor: 'white',
		borderRadius: '4px',
		height: '40px',
		lineHeight: '40px',
		margin: '0px',
		'& .MuiSelect-select': {
			fontFamily: 'Lato, sans-serif',
			fontSize: '12px',
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			display: 'block',
			textAlign: 'left',
    },
		'& div': {
			height: '40px'
		},
		'& div div': {
			display: 'flex',
			alignItems: 'center'
		},
		'& .MuiInputLabel-shrink': {
			display: 'none'
		},
		'& label': {
			transform: "translate(14px, 15px) scale(1)"
		},
		'& .MuiOutlinedInput-root': {
			'&.Mui-focused fieldset': {
				'& label': {
					display: 'none'
				}
			},
			'& fieldset': {
				display: 'none'
			}
    },
	},
	selectInput: {
		'&:hover': {
			display: 'none'
		},
	},
	button: {
		width: '100%',
		height: '40px',
		fontFamily: 'Lato, sans-serif',
		fontStyle: 'bold',
		fontWeight: '700',
		fontSize: '12px',
		color: '#ffffff',
		borderRadius: '4px',
		backgroundColor: '#D91B5B',
		'&:hover': {
			backgroundColor: '#D91B5B',
		},
	},
	tabStyles: {
		borderRadius: '30px',
		border: '1px solid #78CDD0',
		margin: '0 3%',
		textTransform: 'none',
		'@media (max-width:900px)': {
			margin: '0 3% 10px 0'
		},
	},
	tabs: {
		display: 'flex',
		width: '100% !important',
		'& .MuiTabs-flexContainer': {
			width: '100%',
			margin: '15px 0',
			justifyContent: 'space-evenly',
			'& .MuiButtonBase-root': {
				minHeight: '30px',
			},
			'@media (max-width:900px)': {
				justifyContent: 'center',
				flexWrap: 'wrap'
			}
		},
		'& .Mui-selected': {
			color: 'white',
			backgroundColor: '#78CDD0'
		}
	},
	paginationText: {
		color: 'black'
	},
	paginationCurrent: {
		backgroundColor: '#D91B5B',
		borderRadius: '50%',
		width: '32px',
		height: '32px',
	},
	activeButton: {
		backgroundColor: '#211D31',
		color: 'white'
	},
	appBarModal: {
		position: 'relative',
		backgroundColor: '#211D31',
		padding: '20px'
	},
	filters: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		paddingTop: '5px',
		'& .MuiFormControl-root': {
			marginRight: '10px',
			padding: '0 !important',
		},
		'& .MuiBox-root': {
			padding: '0 !important',
		},
	},
	mobileFiltersContainer: {
		'& .MuiDialog-container .MuiPaper-root': {
			backgroundColor: '#211D31',
			padding: '20px'
		}
	},
	clearFilters: {
		color: '#D91B5B !important',
		fontWeight: '700',
		fontSize: '15px',
		fontFamily: 'Lato, sans-serif',
		textDecoration: 'underline',
		cursor: 'pointer',
	},
	paper: {
    height: 140,
    width: 100,
  },
	filterItem: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		width: '25%',
		height: '40px',
		'@media (max-width:768px)': {
			width: '100%',
		}
	},
	filterButton: {
		alignSelf: 'flex-start',
		marginRight: 0,
		textTransform: 'uppercase',
		'@media (max-width:768px)': {
			justifyContent: 'center',
		},
	},
	cardsContainer: {
		display: 'grid',
		gridTemplateColumns: {
			xs: '1fr',
			sm: 'repeat(2, 1fr)',
			md: 'repeat(3, 1fr)',
			lg: 'repeat(4, 1fr)'
		},
		gridAutoRows: '1fr',
		rowGap: 3,
		columnGap: 2,
	},
	pagination: {
		marginTop: '16px',
		justifyItems: 'center',
	},
	noEvents: {
		padding: '24px 26px',
		fontSize: '22px',
		fontStyle: 'normal',
		textAlign: 'left',
		fontFamily: 'TT-Interphases-Regular',
		'& a': {
			color: '#1e283b',
			'&:checked': {
				color: '#1e283b',
			},
		},
	},
	textField: {
		color: 'black',
		fontSize: '10px',
		margin: 0,
		'@media (max-width:768px)': {
			width: '70%',
		},
		backgroundColor: 'white',
		borderRadius: '4px',
		height: '40px',
		'& div': {
			height: '40px'
		},
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: 'black',
      },
    },
	},
};
